import { Toaster as SonnerToaster } from 'sonner';

export const Toaster = () => {
  return (
    <SonnerToaster
      position="top-right"
      toastOptions={{
        duration: 2000,
        className: 'font-body',
        style: {
          fontFamily: 'var(--font-body)',
        },
      }}
      richColors
      closeButton
    />
  );
};
